import { render } from "./DialogsNew.vue?vue&type=template&id=116819d2&scoped=true&lang=pug"
import script from "./DialogsNew.js?vue&type=script&lang=js&external"
export * from "./DialogsNew.js?vue&type=script&lang=js&external"

import "./DialogsNew.vue?vue&type=style&index=0&id=116819d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116819d2"]])

export default __exports__